export default class ModalConfig {
  constructor(type, data, size, closeFunction) {
    this.type = type;
    this.data = data;
    this.size = size;
    this.closeFunction = closeFunction;
  }
}